// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-bar {
  padding: 0.8rem 0rem;
  border-radius: 0;
  margin-bottom: 0px;
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-transform: uppercase;
  font-size: 20px;
  min-height: 35px;
}

.version {
  margin-top: 15px;
  font-size: 10px;
  margin-right: 15px;
}

.logoImg {
  max-width: 300px;
  max-height: 72px;
}

.background {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: calc(100vh - 105px);
}

.background div {
  background-blend-mode: color, saturation;
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/signin/signin.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,2BAAA;AACF;;AAKA;EACE,wCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,sBAAA;AAFF","sourcesContent":[".bottom-bar {\n  padding: 0.8rem 0rem;\n  border-radius: 0;\n  margin-bottom: 0px;\n  background-color: #ffffff;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  text-transform: uppercase;\n  font-size: 20px;\n  min-height: 35px;\n}\n\n.version {\n  margin-top: 15px;\n  font-size: 10px;\n  margin-right: 15px;\n}\n\n.logoImg {\n  max-width: 300px;\n  max-height: 72px;\n}\n\n.background {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  width: 100%;\n  height: calc(100vh - 105px);\n}\n\n.background img {\n}\n\n.background div {\n  background-blend-mode: color, saturation;\n  flex-shrink: 0;\n  min-width: 100%;\n  min-height: 100%;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
